// @ts-check
import * as React from "react";
import { Input, Select, DatePicker, InputNumber, Tooltip } from "antd";
import { getCustomFieldTypes, validateURL } from "./common";
import moment from "moment";
import TCRichTextEditorv2 from "../components/common/TCRichTextEditorv2";
import UserSelectInput from "../components/common/UserSelectInput";
import {
  CustomField,
  CustomFieldExtraProps,
  CustomFieldType
} from "../services/generated-sdk";
import { AppContext } from "../AppContext";
//import { GetProjectCustomFieldsTypeEnum } from '../services/generated-sdk/apis/CustomFieldsApi';

/*
export interface CustomField {
  name: string;
  label: string;
  type: string;
  default_value: string | null;
  is_required: boolean;
}

export interface TCFormField {
  field: string;
  formField: React.Component;
  formItemProps: {
    label: string;
  };
  decoratorOptions: {
    initialValue: string | null;
    rules: [];
  };
}
*/
const getFormRule = (isRequired, fieldLabel, fieldType) => {
  let rules = [];
  let rule = {};

  let ruleAdded = false;
  if (fieldType == "url") {
    rules.push({
      validator: (rule, value, callback) => {
        try {
          if (validateURL(value)) {
            callback();
          } else {
            throw new Error("Invalid URL");
          }
        } catch (e) {
          console.log({ validate_url_error: e });
          callback(e);
        }
      },
      message: "Invalid URL!"
    });
    ruleAdded = true;
  }
  if (isRequired) {
    rule["required"] = true;
    rule["message"] = `Please enter ${fieldLabel}`;
    rules.push(rule);
    ruleAdded = true;
  }
  if (ruleAdded) {
    return rules;
  }
  return [];
};

const getFieldType = (
  type: CustomFieldType,
  extra: any,
  projectId = null,
  company = null
): JSX.Element => {
  if (type == "dropdown" || type == "multipleSelect") {
    if (extra.options) {
      // if (!extra || !extra.options) {
      //   return <Select style={{ width: "100%" }} />;
      // }
      return (
        <Select
          mode={
            type == "multipleSelect" ||
            (extra.multiple != undefined && extra.multiple === true)
              ? "multiple"
              : "default"
          }
          onChange={e =>
            extra.callback != undefined
              ? extra.callback(extra.fieldName, e, extra.options)
              : {}
          }
          style={{ width: "100%" }}
          placeholder="Please select"
          showArrow={true}
          allowClear={
            extra && extra.allowClear && !extra.multiple ? true : false
          }
          getPopupContainer={triggerNode => triggerNode.parentElement}
        >
          {extra.options.map(option => (
            <Select.Option
              key={String(option.systemValue)}
              value={option.systemValue}
            >
              {option.label}
            </Select.Option>
          ))}
        </Select>
      );
    }
  }

  if (type == "text") return <Input />;
  if (type == "textarea") return <Input.TextArea />;
  if (type == "date") return <DatePicker />;
  if (type == "number") return <InputNumber />;
  if (type == "url") return <Input />;
  if (type == "user") {
    return (
      <UserSelectInput
        projectId={projectId}
        selectProps={{
          placeholder: "Please select",
          allowClear: extra && extra.allowClear ? true : false
        }}
      />
    );
  }
  if (type == "editor") {
    return (
      <TCRichTextEditorv2
        // projectUsers={users.map(pu => ({
        //   ...pu,
        //   value: pu.user.name,
        //   username: pu.user.username,
        //   email: pu.user.email,
        //   link: `${getBaseURL()}/profile/${pu.user.username}`
        // }))}
        // setMentions={(newMentions = []) =>
        //   setMentions(mentions.concat(newMentions))
        // }
        company={company && company.id ? company : null}
        placeholder=""
        onChange={() => {}}
        hideToolbarOptions={["indent", "color", "image"]}
        //key="description"
      />
    );
  }

  return <div>Unable to render this field!</div>;
};

const transformValue = (fieldType, value) => {
  if (fieldType == "date") {
    return value ? moment(value) : undefined;
  }
  if (
    (fieldType === "multipleSelect" || fieldType == "dropdown") &&
    (value == null || value === "null")
  )
    return undefined;
  if (fieldType == "number" && value === "null") return null;
  return value;
};

export const customFieldToAnt = (
  cf: CustomField,
  projectId = null,
  company = null
) => {
  // const { company } = React.useContext(AppContext);
  if (!cf) {
    console.error("No custom field passed!");
    return;
  }
  let _formField = {
    field: cf.name,
    formField: getFieldType(
      cf.type,
      { ...cf.extra, allowClear: cf.isRequired ? false : true },
      projectId,
      company
    ),
    formItemProps: {
      label:
        cf.description && cf.description !== "0" ? (
          <Tooltip title={cf.description}>
            <label>{cf.label}</label>
          </Tooltip>
        ) : (
          cf.label
        )
    },
    decoratorOptions: {
      initialValue: transformValue(cf.type, cf.defaultValue),
      rules: getFormRule(cf.isRequired, cf.label, cf.type)
    }
  };
  if (cf.type == "url") {
    _formField.decoratorOptions["validateTrigger"] = "onBlur";
  }

  return _formField;
};
